import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
interface UserModel {
  userRole?: string[]
}
export interface UserState {
  userProfile: UserModel,
  userSelectedRole?: string 
}

const initialState: UserState = {
  userProfile: {},
  userSelectedRole: ""
}

export const userSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    setUserProfile: (state: UserState, action: PayloadAction<object>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.userProfile = action.payload
    },

    setUserSelectedRole: (state: UserState, action: PayloadAction<string>) => {
      // Reducer to update userSelectedRole
      state.userSelectedRole = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setUserProfile, setUserSelectedRole } = userSlice.actions

export default userSlice.reducer